export const financialLabels = {
  not_recorded: 'Não lançado',
  open: 'Em aberto',
  partial: 'Parcial',
  overdue: 'Vencido',
  settled: 'Quitado',
  cancelled: 'Cancelado',
};
export const financialLabel = status =>
  financialLabels[status] || 'Não informado';
export const money = value =>
  Number(value || 0).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
export const dateLabel = value =>
  value ? value.slice(0, 10).split('-').reverse().join('/') : '—';
export const localDate = () => {
  const date = new Date();
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};
